"use strict";
/* globals module */
/**
 * @module userProfileRoute
 * @description Baasic User Profile Route Definition provides Baasic route templates which can be expanded to Baasic REST URIs. Various services can use Baasic User Profile Route Definition to obtain needed routes while other routes will be obtained through HAL. By convention, all route services  use the same function names as their corresponding services.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var inversify_1 = require("inversify");
var common_1 = require("../../../common");
;
var _1 = require("./");
var contracts_1 = require("../../../core/contracts");
var UserProfileRoute = /** @class */ (function (_super) {
    tslib_1.__extends(UserProfileRoute, _super);
    function UserProfileRoute(appOptions, userProfileACLRoute) {
        var _this = _super.call(this, appOptions) || this;
        _this.appOptions = appOptions;
        _this.userProfileACLRoute = userProfileACLRoute;
        _this.findRoute = 'profiles/{?searchQuery,page,rpp,sort,embed,fields}';
        _this.getRoute = 'profiles/{id}/{?embed,fields}';
        _this.createRoute = 'profiles';
        _this.updateRoute = 'profiles/{id}';
        _this.deleteRoute = 'profiles/{id}';
        return _this;
    }
    Object.defineProperty(UserProfileRoute.prototype, "acl", {
        get: function () {
            return this.userProfileACLRoute;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Parses find user profile route which can be expanded with additional options. Supported items are:
     * - `searchQuery` - A string value used to identify user profile resources using the phrase search.
     * - `page` - A value used to set the page number, i.e. to retrieve certain user profile subset from the storage.
     * - `rpp` - A value used to limit the size of result set per page.
     * - `sort` - A string used to set the user profile property to sort the result collection by.
     * - `embed` - Comma separated list of resources to be contained within the current representation.
     * @method
     * @param options Query resource options object.
     * @example userProfileRoute.find.({searchQuery: '<search-phrase>'});
     **/
    UserProfileRoute.prototype.find = function (options) {
        return _super.prototype.baseFind.call(this, this.findRoute, options);
    };
    /**
     * Parses get route; this route doesn't expose any properties.
     * @method
     * @param id User profile id which uniquely identifies user profile resource that needs to be retrieved.
     * @param options Query resource options object.
     * @example userProfileRoute.get(id, options);
     **/
    UserProfileRoute.prototype.get = function (id, options) {
        return _super.prototype.baseGet.call(this, this.getRoute, id, options);
    };
    /**
     * Parses create user profile route; this URI template does not expose any additional options.
     * @method
     * @example baasicUserProfileRouteService.create();
     **/
    UserProfileRoute.prototype.create = function () {
        return _super.prototype.baseCreate.call(this, this.createRoute, {});
    };
    /**
     * Parses update user profile route; this URI template does not expose any additional options.
     * @method
     * @param data An user profile object used to update specified user profile resource.
     * @example baasicUserProfileRouteService.update(data);
     **/
    UserProfileRoute.prototype.update = function (data) {
        return _super.prototype.baseUpdate.call(this, this.updateRoute, data);
    };
    /**
     * Parses update user profile route; this URI template does not expose any additional options.
     * @method
     * @param data An user profile object used to delete specified user profile resource.
     * @example baasicUserProfileRouteService.delete(data);
     **/
    UserProfileRoute.prototype.delete = function (data) {
        return _super.prototype.baseDelete.call(this, this.deleteRoute, data);
    };
    var _a, _b;
    UserProfileRoute = tslib_1.__decorate([
        tslib_1.__param(0, inversify_1.inject(contracts_1.TYPES.IAppOptions)),
        tslib_1.__param(1, inversify_1.inject(_1.TYPES.UserProfileACLRoute)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof contracts_1.IAppOptions !== "undefined" && contracts_1.IAppOptions) === "function" ? _a : Object, typeof (_b = typeof _1.UserProfileACLRoute !== "undefined" && _1.UserProfileACLRoute) === "function" ? _b : Object])
    ], UserProfileRoute);
    return UserProfileRoute;
}(common_1.BaseRoute));
exports.UserProfileRoute = UserProfileRoute;
/**
 * @copyright (c) 2017 Mono Ltd
 * @license MIT
 * @author Mono Ltd
 * @overview
 ***Notes:**
 - Refer to the [Baasic REST API](http://dev.baasic.com/api/reference/home) for detailed information about available Baasic REST API end-points.
 - [URI Template](https://github.com/Baasic/uritemplate-js) syntax enables expanding the Baasic route templates to Baasic REST URIs providing it with an object that contains URI parameters.
 - All end-point objects are transformed by the associated route definition.
 */ 
